import CourseDescriptionContext from '@/context/CourseDescriptionContext';
import StyleHtml from '@/HOCs/StyleHtml';
import { sanitizeDescriptionHtml } from '@/utils/GlobalCommonFunctions';
import { Container, Typography } from '@pwskills/rachnaui';
import { useContext } from 'react';

const AboutTheCourse = () => {
  const { courseDetails } = useContext(CourseDescriptionContext);
  const { courseMetaDetails } = courseDetails || {};
  const { aboutTheCourse } = courseMetaDetails || {};

  return (
    <div className="bg-white">
      <Container
        id="category-hero-section"
        className="!py-14 large:!py-[96px] flex flex-col gap-6 medium:gap-9 !px-4 medium:!px-8 large:!px-20"
      >
        <Typography
          component="h4"
          variant="regular"
          className="text-gray-850  !font-semibold medium:!font-normal !text-[16px] medium:!text-[20px] !leading-[24px] medium:!leading-[30px]"
        >
          About the course
        </Typography>
        <div className="flex flex-col gap-6 medium:gap-9 large:gap-[54px]">
          <StyleHtml>
            <div
              style={{
                wordBreak: 'break-word',
                textJustify: 'auto',
                overflowY: 'hidden',
                overflowX: 'hidden',
              }}
              dangerouslySetInnerHTML={{
                __html: sanitizeDescriptionHtml(aboutTheCourse?.primaryText as string),
              }}
            />
          </StyleHtml>
          <div className="flex flex-col-reverse large:flex-row gap-y-6 gap-x-[146px] items-center">
            <img
              src={aboutTheCourse?.imageUrl}
              alt="about the course icon"
              className="rounded-lg w-full large:!w-[396px] h-auto"
            />
            <StyleHtml>
              <div
                style={{
                  wordBreak: 'break-word',
                  textJustify: 'auto',
                  overflowY: 'hidden',
                  overflowX: 'hidden',
                }}
                dangerouslySetInnerHTML={{
                  __html: sanitizeDescriptionHtml(aboutTheCourse?.secondaryText as string),
                }}
              />
            </StyleHtml>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default AboutTheCourse;
